export const adminsApiErrorsTranslations = {
  INVALID_PHONE_NUMBER: 'validation:invalidPhoneNumber',
} as const;
